module.exports = __webpack_public_path__ + "static/img/2areaA_2.82d1139.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/animal/2areaA_2.png
// module id = 810
// module chunks = 1